/**
 * NotePopup `type` values for caregiver/visit notes (Start+End datetime).
 * CPT monitoring codes (9898X / 9945X) are separate and only Date+timer.
 * Keep in sync with NotePopup <option value="..."> and HomeGrid defaults.
 */
export const CAREGIVER_NOTE_TYPES = [
  "Nursing",
  "Providers",
  "Home Health Aid",
  "Allied Professional",
  "Geriatric Care Manager",
];

export function isCaregiverNoteType(type) {
  return CAREGIVER_NOTE_TYPES.includes(String(type || "").trim());
}

/**
 * Map MySQL account_user.account_type → NotePopup type string. The bridge
 * answers main's words (`Home Health Aid`: getAllData's manager and user,
 * GetAccountType); the API's slug (`home_health_aid`) reads the same once its
 * underscores are spaces.
 */
export function noteTypeForAccountType(accountType) {
  const t = String(accountType || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, " ");
  if (t === "provider") return "Providers";
  if (t === "allied professional") return "Allied Professional";
  if (
    t === "home health aid" ||
    t === "home health aide" ||
    t === "home health aids" ||
    t === "home health aides"
  ) {
    return "Home Health Aid";
  }
  if (t === "geriatric care manager") return "Geriatric Care Manager";
  // RN / LPN / Nurse / Administrator / unknown → Nursing (legacy default).
  return "Nursing";
}
